import React, {Component} from 'react'
import EnterIcon from '../assets/Enter_Arrow_Right.svg'
import UpdatePopover from './common/popover/updatePopover'
import { formatDetectionDatetime } from '../utilities/datetime'
import './ThreatIntelGrid.scss'
import '../components/common/grid/grid.scss'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { loadThreatIntel, fetchThreatIntelScreenshot } from '../store/entities/threatintel'
import { withRouter } from 'react-router-dom';

class ThreatIntelGrid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageSize: this.props.pageSize,
            resetOnChange: false
        }
    }


    componentDidMount() {
        this.fetchScreenshotsForEvents(this.props.events);
    }

    componentDidUpdate(prevProps) {
        // Only fetch for new events
        if (prevProps.events !== this.props.events) {
            this.fetchScreenshotsForEvents(this.props.events);
        }
    }

    fetchScreenshotsForEvents = (events) => {
        const { screenShots, fetchThreatIntelScreenshot, selectedCustomer } = this.props;
        events.forEach(event => {
            // Only fetch if not already loaded
            if (!screenShots || !screenShots[event.id]) {
                fetchThreatIntelScreenshot(event.id, selectedCustomer?.id);
            }
        });
    }

    // onDetails = (item) => {
    //         this.props.history.push(`/threat-intel-feed/${item.id}`);
    // };
    render() {
        const screenshotPlaceholder = `${process.env.REACT_APP_EXTERNAL_PAGES_BASE_URL}/placeholders/screenshot.jpeg`;
        const { events , screenShots, screenshotLoading, pageNo, displaySize, isLastPage, onDetails, showUpdatePopover} = this.props;
        return (
             <div className="d-flex flex-column pageContainer">
                <div style={{ minWidth: '290px' }}>
                    <b>
                    Results (
                    {((pageNo - 1) * displaySize) + events.length}
                    {isLastPage ? '' : `+`}
                    )
                </b>
            </div>
             <div className="d-flex flex-column grid-container mt-3">
              <div className={'grid-body'} >
            <div className="grid-card d-inline-flex flex-wrap" style={{ padding: '16px' }}>
            <Row style={{ marginLeft: '0px', width: '1276px' }}>
                {events.map((record, index) => (
                    <Col
                        xs="6"
                        sm="6"
                        md="6"
                        lg="6"
                        xl="6"
                        style={{ padding: '0px', marginBottom: ' 16px' }}
                        key={index}
                    >
                    <div
                    key={record.id}
                    className="grid-item"
                    style={{ marginRight: '0px' }}
                    >
                    <div className="d-flex mb-2 align-items-center">
                        {<span className={`mr-auto verify-status pixmVerifiedText`}>
                            <b>{record.isVerified ? 'PIXM Verified' : 'AI Suspicious'}</b>
                        </span>}
                        <div
                        className="grid-text font-weight-normal"
                        style={{ marginRight: '0.2rem' }}
                        >
                        { showUpdatePopover && <UpdatePopover {... this.props} role="PixmAdmin" event={record} from="ThreatIntelGrid" />}
                        </div>
                    </div>
                    <div
                        key={record.id}
                        className="image-container mb-2"
                        style={{
                        lineHeight: '150px',
                        textAlign: 'center',
                        }}
                    >
                        {(screenshotLoading[record.id] === true) ? <div className='loader'></div> :
                          (<img  
                            src={screenShots[record.id] || screenshotPlaceholder}
                            style={{
                            borderRadius: '5px',
                            maxWidth: '582px',
                            maxHeight: '254px',
                            }}
                            alt=""
                            srcSet=""
                        />) 
                    }
                        
                    </div>

                    <div>
                        <table style={{ width: '100%', tableLayout: 'fixed' }}>
                        <tbody>
                            <tr style={{ background: 'white' }}>
                            <td width="55%">
                                <div
                                className="textWrap"
                                title={record.threatURL}
                                style={{ width: '95%' }}
                                >
                                {record.threatURL}
                                </div>
                            </td>
                            <td width="30%">
                                <div
                                style={{ width: '95%', color: 'rgb(45, 95, 167)' }}
                                title={record.detectedBrands || 'NA'}
                                className="textWrap"
                                >
                                <b>{record.detectedBrands || 'NA'}</b>
                                </div>
                            </td>
                            </tr>
                            <tr>
                            <td width="55%">
                                <div
                                style={{ width: '95%' }}
                                title={formatDetectionDatetime(record.threatDetectedOn)}
                                className="textWrap font-italic"
                                >
                                Opened at{' '}
                                {formatDetectionDatetime(record.threatDetectedOn)}
                                </div>
                            </td>
                            <td width="5%" style={{ paddingLeft: '0px' }}>
                                {' '}
                                <img
                                style={{ cursor: 'pointer', width: '30px' }}
                                onClick={() => onDetails(record)}
                                src={EnterIcon}
                                alt="next-icon"
                                />
                            </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                    </div>
                </Col>
                ))}
            </Row>
            </div>
            </div>
            </div>
            {/* <div className={`d-flex justify-content-center align-items-end`} >
                <Pagination
                    isLastPage={this.props.isLastPage}
                    getNextPageData={this.getNextPageData}
                    getPrevPageData={this.getPrevPageData}
                    pageSize={20}
                    resetOnChange={this.state.resetOnChange}
                    loaderFlag={this.props.loading}
                    />
            </div> */}
            </div>
  )
    }

}

const mapStateToProps = (state) => ({
    events: state.entities.threatintel.events,
    screenShots: state.entities.threatintel.screenshots,
    screenshotLoading: state.entities.threatintel.screenshotsLoading,
    isLastPage: state.entities.threatintel.isLastPage,
    loading: state.entities.threatintel.eventsLoading,
    displaySize: state.entities.threatintel.displaySize,
    selectedCustomer: state.entities.customers.selected,
});

const mapDispatchToProps = (dispatch) => ({
    fetchThreatIntelScreenshot: (id, cid) => dispatch(fetchThreatIntelScreenshot(id, cid)),
    loadThreatIntel: (filters, sorting, pageNo, pageSize) => dispatch(loadThreatIntel(filters, sorting, pageNo, pageSize)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ThreatIntelGrid));